import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'

interface Props {
  amount: string
  accrualCycle: Cycle | null | undefined
  accruedOnPrevCycle: boolean
}

const Total = ({ amount, accrualCycle, accruedOnPrevCycle }: Props) => {
  const generatedOnLabel = accrualCycle?.yearLabel

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal color="grey000White">{i18n.t('time_off.accrued_tooltip.total')}</Text.Normal>
        <Text.Normal color="grey000White">{amount}</Text.Normal>
      </Box>
      {accrualCycle && (
        <Box flexDirection="row" justifyContent="flexStart">
          <Text.Normal size="200" color="grey000White">
            {accruedOnPrevCycle &&
              i18n.t('time_off.accrued_tooltip.generated_on', {
                when: generatedOnLabel,
              })}
            {!accruedOnPrevCycle &&
              i18n.t('time_off.accrued_tooltip.since', {
                when: accrualCycle.begin.format('MMMM YYYY'),
              })}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default observer(Total)
